import { render } from "./SpacerElement.vue.js?vue&type=template&id=37ad96d4!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SpacerElement.vue?vue&type=template&id=37ad96d4"
import script from "./SpacerElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SpacerElement.vue?vue&type=script&lang=js"
export * from "./SpacerElement.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SpacerElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-components/render-engine/components/production/elements/spacer-element/SpacerElement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37ad96d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37ad96d4', __exports__)) {
    api.reload('37ad96d4', __exports__)
  }
  
  module.hot.accept("./SpacerElement.vue.js?vue&type=template&id=37ad96d4!=!../../../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SpacerElement.vue?vue&type=template&id=37ad96d4", () => {
    api.rerender('37ad96d4', render)
  })

}


export default __exports__